import React, { AllHTMLAttributes, FC, PropsWithChildren } from 'react';

import { cn } from '../../../utils';

import './MainGrid.scoped.scss';

interface Props extends AllHTMLAttributes<HTMLDivElement> {}

const MainGrid: FC<PropsWithChildren<Props>> = ({ children, ...props }) => {
  return (
    <div {...props} className={cn('main-grid', props.className)}>
      {children}
    </div>
  );
};

export default MainGrid;
